import(/* webpackMode: "eager" */ "/var/www/vhosts/admin.phucbaokhang.vn/httpdocs/app/src/app/error.tsx");
